<script>
    // import ItemPlayer from './ItemPlayer.svelte';
    import { db } from './firebase';
    let usernames=[];
    let tempUsernames=[];
    let username;
    const whitelistRef = db.collection("whitelist").doc("usernames");

    // db.collection("whitelist").doc("usernames")
    whitelistRef
    .onSnapshot(function(doc) {
        console.log('doc data:',doc.data());
        usernames = [...doc.data().approved];
    });

    function saveToDatabase(newList){
        whitelistRef.set({
            approved: newList
        })
        .then(function() {
            console.log("Document successfully written!");
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });

    }

    function addUsername() {
        console.log('addUsername: ',username);
        tempUsernames = [...usernames, username];
        saveToDatabase(tempUsernames);
        username = '';
        console.log('usernames: ',tempUsernames);
    }

    function removeUsername(removeUser) {
        console.log('removeUser: ',removeUser);
        tempUsernames = usernames.filter(user => user !== removeUser);
        console.log('remove username: ',tempUsernames);
        saveToDatabase(tempUsernames);

    }
</script>

<div id="container">
    <input bind:value={username} placeholder="Username to add">
    <button on:click={addUsername}>
        Add
    </button>
    <ul>
        {#each usernames as username}
            <li>
                {username} <button on:click={() => removeUsername(username)}>remove</button>
            </li>
        {/each}

    </ul>
</div>

<style>
    #container {
        display: inline-block;
    }

    button {
        cursor: pointer;
    }
</style>

